// localStorage key for verifying redirect URI
export const REDIRECT_STATE = 'spot_redirect_state';
// localStorage key for auth code
export const AUTH_CODE = 'spot_auth_code';
// Auth page name
export const AUTH_PAGE = 'auth';

export const LANG_MAP = {
  'en-US': 'en',
  'en-GB': 'en',
  'en-AU': 'en',
  'en-CA': 'en',
  'en-IN': 'en',
  'en-NL': 'en',
  'en-SE': 'en',
  'ja-JP': 'en',
  'en-SG': 'en',
  'es-MX': 'es-MX',
  'es-ES': 'es-ES',
  'de-DE': 'de-DE',
  'it-IT': 'it-IT',
  'fr-FR': 'fr-FR',
  'pt-BR': 'pt-BR',
  default: 'en',
};
